<template>
    <transition name="fade">
        <div>
            <div id="ai-generate-image-modal">
                <div class="modal-backdrop" @click.stop="closeByBackdrop">
                    <div class="modal-content relative">
                        <RobotLoader
                            v-if="isLoading"
                            :show-progress-bar="showRobotProgress"
                            :progress="currentProgress"
                            :total-progress="totalProgress"
                            :error-progress="errorProgress"
                        />

                        <div v-if="showSorryAlert" id="error-box">
                            <div class="error-box-content p-4 bg-white">
                                <div class="content-box flex items-center d-flex align-items-center">
                                    <svg class="cry-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 650 649.99">
                                        <path
                                            d="m0,325C0,145.5,145.5,0,325,0h0c179.49,0,324.98,145.5,325,325h0c-.02,179.49-145.51,324.99-325,324.99h0C145.5,649.98,0,504.49,0,325h0ZM117.08,117.07c-53.23,53.26-86.12,126.67-86.12,207.92h0c0,81.25,32.89,154.66,86.12,207.92h0c53.26,53.24,126.68,86.12,207.92,86.12h0c81.24,0,154.65-32.88,207.92-86.12h0c53.23-53.26,86.12-126.67,86.12-207.92h0c0-81.26-32.89-154.66-86.12-207.92h0c-53.27-53.24-126.68-86.12-207.92-86.12h0c-81.25,0-154.67,32.88-207.92,86.12h0Zm-13.26,117.41c7.13-16.57,28.36-43.39,65.96-58.58,36.85-14.89,63.48-10.08,63.48-15.75,0-7.15-33.16-19.83-75.61,1.56-46.17,23.26-54.63,59.21-53.83,72.77Zm388.55-72.77c-42.45-21.39-75.62-8.71-75.62-1.56,0,5.67,26.64.86,63.48,15.75,37.6,15.19,58.83,42.01,65.96,58.58.8-13.57-7.65-49.51-53.83-72.77Zm-167.31,336.98c50.06,0,87.6,30.75,93.69,24.65,2.27-12.57-34.97-62.42-92.5-63.8-57.54,1.37-97.64,51.22-94.94,63.8,6.09,6.11,43.64-24.65,93.69-24.65h.07Zm-79.18-107.54c-3.43-6.82-7.03-13.15-10.18-18.38-2.49-4.14-4.69-7.6-6.33-10.09-1.58-2.42-2.6-3.9-2.81-4.2l-2.84-4.02-2.81,4.04c-.15.22-.68,1-1.54,2.29-1.63,2.46-4.35,6.67-7.54,12.02-3.13,5.24-6.7,11.58-10.12,18.42-7.08,14.28-13.58,30.56-13.63,44.29v.03s0,.1,0,.17c.02,4.28.79,8.4,2.2,12.22,1.81,4.92,4.67,9.32,8.32,12.95h0s0,0,0,0c4.23,4.22,9.51,7.38,15.42,9.07,3.05.88,6.28,1.35,9.6,1.38h0s.25,0,.25,0h.04c4.06-.01,7.97-.7,11.62-1.96,5.2-1.8,9.86-4.76,13.67-8.57,3.62-3.64,6.48-8.06,8.28-13,1.33-3.63,2.08-7.54,2.16-11.6v-.02s0-.74,0-.74c-.08-13.74-6.63-30.03-13.78-44.31Zm-42.4,64.86c-2.94-2.93-5.25-6.49-6.72-10.46-1.15-3.1-1.77-6.45-1.78-9.97v-.22h0c0-11.52,6.02-27.32,12.91-41.05,3.31-6.64,6.8-12.83,9.87-17.96,2.35-3.94,4.44-7.25,6-9.66,1.58,2.4,3.68,5.71,6.04,9.64,3.08,5.12,6.59,11.3,9.92,17.93,6.96,13.74,13.03,29.57,13.05,41.1,0,.05,0,.1,0,.14h0c0,3.52-.61,6.87-1.75,9.97-1.45,3.98-3.75,7.55-6.68,10.49-3.07,3.08-6.84,5.47-11.04,6.92-2.93,1.02-6.08,1.57-9.38,1.58h-.01c-2.77,0-5.44-.38-7.97-1.11-4.76-1.36-9.03-3.92-12.45-7.33h0Zm20.4-216.3c-21.97,0-39.78,23.63-39.78,52.78s17.82,52.78,39.78,52.78,39.78-23.63,39.78-52.78-17.8-52.78-39.78-52.78Zm202.29,0c-21.97,0-39.78,23.63-39.78,52.78s17.82,52.78,39.78,52.78,39.78-23.63,39.78-52.78-17.81-52.78-39.78-52.78Z"
                                        />
                                    </svg>
                                    <p v-if="errorMessage">
                                        {{ renderErrorMessage }}

                                        <span
                                            v-if="promptInvalidReason"
                                            class="block d-block text-sm p-2 rounded mt-2"
                                            style="background-color: #dae1e7"
                                            ><strong>{{ translate('ai_reason', 'AI Reason') }}:</strong>
                                            {{ promptInvalidReason }}</span
                                        >
                                    </p>
                                </div>
                                <div
                                    class="flex justify-center items-center d-flex justify-content-center align-items-center mt-3"
                                >
                                    <button
                                        @click="showSorryAlert = false"
                                        type="button"
                                        class="p-2 p-6 font-opensans btn btn-secondary system-button-color system-button-text-color"
                                    >
                                        {{ translate('robot_sorry_modal_button_close', 'Close') }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="modal-header pb-2">
                            <div
                                class="flex justify-between items-center d-flex justify-content-between align-items-center"
                            >
                                <h2 class="m-0 font-size-18 md:font-size-20 shadow-text-none">
                                    {{ translate('upload_modal_button_image_ai', 'Generate image with AI') }}
                                </h2>
                                <i
                                    @click.stop="closeModal"
                                    class="fas text-grey fa-times text-xl shadow-text-none cursor-pointer"
                                ></i>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="mx-auto">
                                <div
                                    class="d-flex flex justify-content-between justify-between align-items-center items-center pb-2"
                                    style="font-size: 1rem"
                                >
                                    <div class="mb-2">
                                        <span v-if="backend">Image</span>
                                        <span v-else class="pr-2">
                                            {{
                                                translate('modal_ai_image_number_of_images', {
                                                    limit: limitAiImage
                                                })
                                            }}
                                        </span>
                                    </div>
                                    <div v-if="!backend" :class="{ 'mb-2 ml-auto': true }">
                                        <a
                                            v-if="!isSchoolRole"
                                            @click.prevent="onUpgrade()"
                                            class="font-size-12 shadow-text-none system-primary-text-color"
                                            href="#"
                                        >
                                            {{ translate('robot_modal_upgrade') }}
                                        </a>
                                    </div>
                                </div>

                                <div
                                    class="ai-flex-wrapper justify-center justify-content-center align-items-center items-center"
                                >
                                    <div class="image-panel-box">
                                        <div class="image-panel">
                                            <img
                                                v-if="imageUrl"
                                                class="w-full w-100 h-full h-100"
                                                style="background-position: center; object-fit: cover"
                                                :src="imageUrl"
                                            />
                                            <div v-else style="width: 30%; height: 30%">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="#ced4da"
                                                    viewBox="0 0 576 512"
                                                >
                                                    <path
                                                        d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="prompt-panel-box">
                                        <div
                                            class="d-flex flex justify-content-between justify-between align-items-center items-center"
                                        >
                                            <div class="mb-2">{{ translate('modal_ai_image_prompt', 'Prompt') }}</div>
                                        </div>
                                        <div class="prompt-panel">
                                            <XTextarea
                                                id="prompt-text"
                                                @input="inputPrompt($event)"
                                                :value="promptText"
                                                :placeholder="promptPlaceholder"
                                                maxlength="200"
                                                class="w-full w-100 h-full h-100"
                                                style="font-size: 1rem; text-align: left; font-weight: 400"
                                            ></XTextarea>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="ai-flex-wrapper-btn justify-center justify-content-center"
                                    style="margin-top: 1.5rem"
                                >
                                    <button
                                        @click="onclickGenerate"
                                        :disabled="!promptText"
                                        :class="
                                            imageUrl
                                                ? 'system-button-outline'
                                                : 'system-button-color system-button-text-color'
                                        "
                                        class="font-opensans btn"
                                        id="button-generate-img"
                                        type="button"
                                    >
                                        {{ translate('modal_ai_image_button_generate', 'Generate') }}
                                    </button>
                                    <button
                                        v-if="imageUrl"
                                        @click="chooseImage"
                                        :disabled="!imageUrl"
                                        :class="
                                            imageUrl
                                                ? 'system-button-color system-button-text-color'
                                                : 'system-button-outline'
                                        "
                                        class="font-opensans btn"
                                        id="button-choose-img"
                                        type="button"
                                    >
                                        {{ translate('modal_ai_image_button_choose', 'Choose Image') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <UpgradeAiQuestionModal
                v-if="isShowUpgradeAiQuestionModal"
                @success="onSuccess"
                @close="isShowUpgradeAiQuestionModal = false"
                ref="upgradeAiQuestion"
            />
        </div>
    </transition>
</template>

<script>
import { load } from 'recaptcha-v3'
import RobotLoader from '../../src/components/quiz-creator/question-section/RobotLoader.vue'
import XTextarea from '../../src/components/v2/XTextarea.vue'

let Request, UpgradeAiQuestionModal, popup
let getToken = () => {}
let currentUser = () => {
    return {
        role: ''
    }
}

if (typeof process.env.VUE_APP_IS_BACKEND === 'undefined') {
    Request = require('@/lib/request.js').default
    UpgradeAiQuestionModal = require('@/components/UpgradeAiQuestionModal.vue').default
    popup = require('@/lib/popup').default
    currentUser = require('@/lib/user.js').currentUser
    getToken = require('@/lib/user.js').getToken
}

export default {
    name: 'ai-generate-image-modal',

    components: {
        RobotLoader,
        XTextarea,
        UpgradeAiQuestionModal
    },

    props: {
        title: {
            type: String,
            default: ''
        },

        location: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            isLoading: false,
            promptText: '',
            backend: false,
            limitAiImage: 0,
            imageUrl: '',

            showRobotProgress: false,
            currentProgress: 0,
            totalProgress: 1,
            errorProgress: [],

            showSorryAlert: false,

            isShowUpgradeAiQuestionModal: false,
            errorMessage: 'generate_image_failed',
            promptInvalidReason: ''
        }
    },

    computed: {
        // getPrompt() {
        //     const promptMappers = {
        //         quiz: `Generate image of "${this.title}" to be the quiz image`,
        //         question: `Generate image of "${this.title}" to be the question image`,
        //         answer: `Generate image of "${this.title}" to be the answer image`,
        //         themebgimage: `Generate image of "${this.title}" to be the background image`
        //     }

        //     return promptMappers[this.location] || ''
        // },

        promptPlaceholder() {
            if (this.$i18n) {
                return this.$t('modal_ai_prompt_placeholder')
            } else {
                return 'Describe the image you want to generate. Be specific. For example: "Generate a photo realistic image of a old black dog." You can describe it in any language.'
            }
        },

        isTeacher() {
            return ['teacher', 'teacher_plus'].includes(currentUser().role)
        },

        isSchoolRole() {
            return currentUser().role.includes('teacher') || currentUser().role.includes('student')
        },

        i18n() {
            return this.$t ? true : false
        },

        renderErrorMessage() {
            if (this.i18n) {
                return this.$t(this.errorMessage) || this.$t('generate_image_failed')
            } else {
                const errorMessageMap = {
                    prompt_is_too_short:
                        'We apologize for the inconvenience, but it seems the prompt message was too brief. For better results, try providing a more detailed prompt with specific instructions.',
                    prompt_is_too_long:
                        'We apologize for the inconvenience, but it seems the prompt message was too lengthy. For better results, try condensing your message to focus on key points and specific instructions.',
                    prompt_is_invalid:
                        'The prompt provided appears to be invalid or not in a recognizable format. For the best experience, please use natural language and form coherent sentences.',
                    generate_image_failed:
                        'We apologize for the inconvenience, but there was an issue generating the image. Please try again with more specific details or adjustments to your request.'
                }

                return errorMessageMap[this.errorMessage] || errorMessageMap.generate_image_failed
            }
        }
    },

    mounted() {
        // this.promptText = this.getPrompt

        // if (this.title === 'Untitled' || !this.title) {
        //     this.promptText = ''
        // }

        if (typeof process.env.VUE_APP_IS_BACKEND !== 'undefined') {
            this.backend = true
        }

        if (!this.backend) {
            this.getLimitAiImage()
        }
    },

    methods: {
        closeByBackdrop(e) {
            if (!e.target.classList.contains('modal-backdrop')) {
                return
            }

            this.closeModal()
        },

        closeModal() {
            if (this.isLoading) {
                return
            }

            if (this.imageUrl) {
                this.confirmToClose(() => {
                    this.$emit('close')
                })

                return
            }

            this.$emit('close')
        },

        translate(key, msg) {
            if (typeof process.env.VUE_APP_IS_BACKEND !== 'undefined') {
                return msg
            }

            if (key === 'modal_ai_image_number_of_images') {
                return this.$t(key, msg)
            }

            return this.$t(key)
        },

        async getLimitAiImage() {
            this.isLoading = true

            await this.$store.dispatch('getLimitAiImage').then(res => {
                this.limitAiImage = res.limit

                this.isLoading = false
            })
        },

        async setLimitAiImage() {
            await this.$store.dispatch('setAiImageByUser').then(res => {
                this.limitAiImage = res.left
            })
        },

        onSuccess() {
            this.getLimitAiImage()
        },

        inputPrompt(e) {
            this.promptText = e.target.value
        },

        getRecaptchaSiteKey() {
            return process.env.VUE_APP_RECAPTCHA_SITE_KEY
        },

        onclickGenerate() {
            if (this.backend) {
                this.generateImageBackend()
            } else {
                this.generateImageFrontend()
            }
        },

        async generateImageBackend() {
            this.isLoading = true
            this.showRobotProgress = true
            this.currentProgress = 0
            this.errorProgress = []
            this.promptInvalidReason = ''

            try {
                const generate = await this.$store.dispatch('quiz/generateAiImage', {
                    prompt: this.promptText
                })

                if (generate.status === 200) {
                    this.currentProgress++
                    this.imageUrl = generate.data.data.url
                }
            } catch (error) {
                this.currentProgress++
                this.errorProgress = [1]
                if (error.response) {
                    this.errorMessage = error.response.data.message

                    if (error.response.data.reason) {
                        this.promptInvalidReason = error.response.data.reason.trim()
                    }
                }
            }

            setTimeout(() => {
                this.isLoading = false

                if (this.errorProgress.length) {
                    this.showSorryAlert = true
                }
            }, 500)
        },

        async generateImageFrontend() {
            if (this.limitAiImage <= 0) {
                if (this.isTeacher) {
                    return popup.alert(this.$t('robot_modal_alert_limit_image'))
                } else {
                    return popup.confirm(
                        this.$t('robot_modal_alert_limit_image'),
                        () => {
                            this.isShowUpgradeAiQuestionModal = true
                        },
                        () => {},
                        {
                            customButtons: {
                                ok: {
                                    text: this.$t('robot_modal_button_add_purchase_image'),
                                    className: 'btn font-opensans text-md system-button-color system-button-text-color'
                                }
                            }
                        }
                    )
                }
            }

            this.isLoading = true
            this.showRobotProgress = true
            this.currentProgress = 0
            this.errorProgress = []
            this.promptInvalidReason = ''

            const url = `${process.env.VUE_APP_CHATGPT_BASE_URL}/generate-image`

            try {
                const recaptcha = await load(this.getRecaptchaSiteKey(), {
                    useRecaptchaNet: true,
                    autoHideBadge: true
                })

                const token = await recaptcha.execute('validate_captcha', { action: 'validate_captcha' })
                const request = new Request({
                    headers: {
                        Authorization: `Bearer ${getToken()}`
                    }
                })
                const generate = await request.post(url, {
                    captcha_token: token,
                    prompt: this.promptText
                })

                if (generate.status === 200) {
                    this.currentProgress++
                    this.imageUrl = generate.data.data.url

                    this.setLimitAiImage()
                }
            } catch (error) {
                this.currentProgress++
                this.errorProgress = [1]
                if (error.response) {
                    this.errorMessage = error.response.data.message

                    if (error.response.data.reason) {
                        this.promptInvalidReason = error.response.data.reason.trim()
                    }
                }
            }

            setTimeout(() => {
                this.isLoading = false

                if (this.errorProgress.length) {
                    this.showSorryAlert = true
                }
            }, 500)
        },

        chooseImage() {
            this.$emit('image-selected', this.imageUrl)
        },

        onUpgrade() {
            this.isShowUpgradeAiQuestionModal = true
        },

        popup() {
            let popup

            try {
                popup = require('@/lib/popup.js').default
            } catch {
                if (typeof window.shout != 'undefined') {
                    popup = window.shout
                    popup.alert = popup.error
                }
            }

            return popup
        },

        confirmToClose(acceptCallback) {
            const msg = this.translate(
                'setting_confirm_close',
                'Are you certain you want to close? Any unsaved changes will be lost'
            )

            if (typeof process.env.VUE_APP_IS_BACKEND !== 'undefined') {
                this.$vueConfirm.confirm(
                    {
                        message: msg,
                        button: {
                            no: 'No',
                            yes: 'Yes'
                        }
                    },
                    function (confirm) {
                        if (confirm) {
                            if (acceptCallback) {
                                acceptCallback()
                            }
                        }
                    }
                )
            } else {
                this.popup().confirm(msg, () => {
                    if (acceptCallback) {
                        acceptCallback()
                    }
                })
            }
        }
    }
}
</script>

<style lang="scss">
#ai-generate-image-modal {
    .modal-body {
        padding: 1rem;
    }

    .modal-header {
        padding: 1rem 1rem 0rem 1rem;
        display: block;
        border: none;
        position: relative;
        border-bottom: none !important;

        i {
            color: var(--dark-color);
            font-size: 20px !important;
        }

        h2 {
            font-size: 20px;

            @media screen and (max-width: 767px) {
                font-size: 18px;
            }
        }
    }

    .modal-backdrop {
        background-color: rgba(0, 0, 0, 0.2);
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: start;
        font-size: 0.5rem;
        z-index: 9999;
        overflow: auto;

        .modal-content {
            background-color: var(--light-color);
            margin-top: 5rem;
            min-width: 620px;
            max-width: 620px;
            overflow: hidden;
            border-radius: 3px;
            box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.6);

            @media screen and (max-width: 675px) {
                min-width: 90%;
                margin: 1rem;
            }

            .modal-header {
                .close {
                    background-color: transparent;
                    position: absolute;
                    right: 1rem;
                    top: 1rem;
                }
            }

            .modal-body {
                margin: 0;
            }

            .image-panel-box {
                width: 350px;

                @media screen and (max-width: 420px) {
                    width: 100%;
                }
            }

            .prompt-panel-box {
                width: 100%;
                font-size: 1rem;
                margin-top: 1rem;
            }

            .image-panel-box .image-panel,
            .prompt-panel-box .prompt-panel {
                flex: 1;
                border: 1px solid #8d8d8d;
                border-radius: 5px;
                height: 330px;
                overflow: hidden;
            }

            .prompt-panel {
                height: 96px !important;
            }

            .image-panel {
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .prompt-panel {
                #prompt-text.textarea::placeholder {
                    text-align: left;

                    @media screen and (max-width: 675px) {
                        font-size: 0.8rem;
                    }
                }
            }

            .ai-flex-wrapper,
            .ai-flex-wrapper-btn {
                display: flex;
                flex-direction: column;
                column-gap: 1rem;
                row-gap: 0.75rem;
            }

            .ai-flex-wrapper-btn {
                flex-direction: row;
            }

            #button-generate-img,
            #button-choose-img {
                width: 100%;
                padding: 0.5rem;
            }

            @media screen and (max-width: 675px) {
                .image-panel {
                    height: 300px !important;
                }
            }
        }
    }

    #error-box {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        background-color: rgba(0, 0, 0, 0.3);
        width: 100%;
        height: 100%;
        z-index: 99;

        .error-box-content {
            font-size: 1rem;
            max-width: 500px;
            border-radius: 0.3rem;
            -webkit-box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.5);
            box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.5);

            .content-box {
                column-gap: 1rem;

                .cry-icon {
                    width: 50%;
                    fill: #6c757d;
                }
            }
        }
    }
}
</style>
